<template>
  <div class="meal-holiday-config">
    <div class="lvyun-profile-banner">
      <h2>排餐配置</h2>
      <p>维护法定节假日、调休工作日及中餐/晚餐超时扣减截止时间。</p>
    </div>

    <el-card class="settings-card" shadow="never">
      <template slot="header">
        <div class="card-header">
          <div class="card-title">超时扣减阈值</div>
        </div>
      </template>
      <el-form :inline="true" label-width="120px">
        <el-form-item label="中餐截止时间">
          <el-time-select
            v-model="deductionSettings.lunch_cutoff"
            :picker-options="{ start: '08:00', step: '00:15', end: '14:00' }"
            placeholder="选择时间"
          />
        </el-form-item>
        <el-form-item label="晚餐截止时间">
          <el-time-select
            v-model="deductionSettings.dinner_cutoff"
            :picker-options="{ start: '15:00', step: '00:15', end: '22:00' }"
            placeholder="选择时间"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn-primary" @click="saveDeductionSettings">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="action-card" shadow="never" style="margin-top: 20px;">
      <template slot="header">
        <div class="card-header">
          <div class="card-title">节假日 / 调休配置</div>
          <el-button type="primary" icon="el-icon-plus" class="btn-primary" @click="showAddDialog">新增</el-button>
        </div>
      </template>

      <el-table :data="holidayList" stripe style="width: 100%;">
        <el-table-column prop="config_date" label="日期" width="140" />
        <el-table-column label="类型" width="140">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.config_type === 'makeup_workday' ? 'success' : 'warning'">
              {{ scope.row.config_type === 'makeup_workday' ? '调休工作日' : '法定节假日' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="160" />
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="small" class="btn-secondary danger" @click="deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="新增节假日/调休" :visible.sync="dialogVisible" width="480px">
      <el-form label-width="100px">
        <el-form-item label="日期">
          <el-date-picker v-model="form.config_date" type="date" value-format="yyyy-MM-dd" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.config_type" style="width: 100%;">
            <el-option label="法定节假日（跳过排餐）" value="holiday" />
            <el-option label="调休工作日（正常排餐）" value="makeup_workday" />
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="form.name" placeholder="如：春节、调休上班" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" class="btn-primary" @click="submitAdd">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MealHolidayConfig',
  data() {
    return {
      deductionSettings: { lunch_cutoff: '12:00', dinner_cutoff: '18:30' },
      holidayList: [],
      dialogVisible: false,
      form: { config_date: '', config_type: 'holiday', name: '' }
    }
  },
  mounted() {
    this.loadSettings()
    this.loadHolidays()
  },
  methods: {
    async loadSettings() {
      try {
        const resp = await this.$api.get('/admin/meal-schedules/deduction-settings')
        if (resp && resp.code === 200 && resp.data) {
          this.deductionSettings = { ...resp.data }
        }
      } catch (e) {
        // ignore
      }
    },
    async saveDeductionSettings() {
      try {
        const resp = await this.$api.put('/admin/meal-schedules/deduction-settings', this.deductionSettings)
        if (resp && resp.code === 200) {
          this.$message.success('保存成功')
        }
      } catch (e) {
        this.$message.error('保存失败')
      }
    },
    async loadHolidays() {
      try {
        const resp = await this.$api.get('/admin/meal-schedules/holidays', { params: { pageSize: 200 } })
        if (resp && resp.code === 200 && resp.data) {
          this.holidayList = resp.data.list || []
        }
      } catch (e) {
        this.$message.error('加载节假日配置失败')
      }
    },
    showAddDialog() {
      this.form = { config_date: '', config_type: 'holiday', name: '' }
      this.dialogVisible = true
    },
    async submitAdd() {
      if (!this.form.config_date) {
        this.$message.error('请选择日期')
        return
      }
      try {
        const resp = await this.$api.post('/admin/meal-schedules/holidays', this.form)
        if (resp && resp.code === 200) {
          this.$message.success('添加成功')
          this.dialogVisible = false
          this.loadHolidays()
        } else {
          this.$message.error((resp && resp.message) || '添加失败')
        }
      } catch (e) {
        this.$message.error('添加失败')
      }
    },
    async deleteRow(row) {
      try {
        await this.$confirm('确定删除该配置？', '提示', { type: 'warning' })
        const resp = await this.$api.delete(`/admin/meal-schedules/holidays/${row.id}`)
        if (resp && resp.code === 200) {
          this.$message.success('已删除')
          this.loadHolidays()
        }
      } catch (e) {
        // cancel
      }
    }
  }
}
</script>

<style scoped>
.meal-holiday-config {
  padding: 0 4px 24px;
}
.lvyun-profile-banner {
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%);
  border-radius: 12px;
  padding: 24px 28px;
  margin-bottom: 20px;
  border: 1px solid #dbeafe;
}
.lvyun-profile-banner h2 {
  margin: 0 0 8px;
  font-size: 22px;
  color: #1e293b;
}
.lvyun-profile-banner p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}
.settings-card,
.action-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-title {
  font-weight: 600;
  font-size: 16px;
}
</style>
